import gql from 'graphql-tag';

export const GetPrepaidCard = gql`
  query PrepaidCard($cardNumber: String!, $isoCountryCode: String!) {
    prepaidByCardNumber(cardNumber: $cardNumber, isoCountryCode: $isoCountryCode) {
      id: cardNumber
      alias
      cardNumber
      currencyCode
      currentBalance
      expiryMonth
      expiryYear
      transactions {
        amount
        currencyCode
        info
        transactionTime
      }
    }
  }
`;
